const api = (environment, baseServices) => {
  const GET_DOIS_URL = `${environment.apiUrl}/dois`

  return {
    async findDoi (params) {
      const url = baseServices.createUrl(GET_DOIS_URL, params)
      const result = await baseServices.request({ url })
      return result.json()
    }
  }
}

export default api
